import { getField, updateField } from 'vuex-map-fields'
import getTodoFiltersModel from './models/todoFilters'

const todoFilters = {
  namespaced: true,
  state: {
    ...getTodoFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }, userId) {
      return commit('clearFilters', userId)
    }
  },
  mutations: {
    updateField,
    clearFilters (state, userId) {
      state.assignedToUserId = userId || null
      state.targetDate = null
      state.complete = null
      state.onlyMyTasks = null
    }
  }
}

export default todoFilters
